import React from "react"

const Boots = ({ colors = ["#77634F"] }) => {
  return (
    <g id="Boots">
      <path
        fill={colors[0]}
        d="M38.8465195,104.4267883c0,0.4291458-0.6168938,11.0504532-0.6168938,11.0504532l-1.7233543,4.277916 l-0.3620148,0.8986359h3.6946602l0.3754997-4.9083328l2.7357941-11.0772781L38.8465195,104.4267883z"
      />
      <path
        opacity="0.64"
        fill="#21376C"
        d="M36.5062714,119.7551575 c0.1072845,0.0268173,0.999176,0.4426651,1.1601028,0.3890228c0.1609306-0.0536423,1.4215393-0.0536423,1.4215393-0.0536423 l0.7510033-0.3754959v0.9387512h-3.6946602L36.5062714,119.7551575z"
      />
      <path
        opacity="0.42"
        fill="#21376C"
        d="M38.4647446,115.4854889l-0.3491096,1.5876312 c0,0,0.8851089-0.6437149,1.9512634,0.3419724c0.0402336-0.784523-0.864994-1.2471924-1.0661545-1.2673111 c-0.2212753-0.0402298-0.0804634-0.5632553-0.0804634-0.5632553L38.4647446,115.4854889z"
      />
      <path
        opacity="0.42"
        fill="#21376C"
        d="M38.2028046,117.0060654l-0.3486786,1.394722 c0,0,0.8448753-0.5230179,1.6495209,0.2011566c-0.120697-0.6437149-1.2472-0.8046417-1.2472-0.8046417l0.1609306-0.978981 L38.2028046,117.0060654z"
      />
      <path
        opacity="0.42"
        fill="#21376C"
        d="M40.417141,105.3716583l0.1459351-0.9448853 l-0.5900269,0.0805054l-0.0684204,0.9187622l-0.4412231,0.046814c0,0,0.0268555,1.2069702,0.0805054,1.1533203 c0.0095215-0.0095215,0.1125488-0.0059814,0.2709351,0.0049438l-0.0773315,1.0385132l-0.2741089,0.0025635 c0,0,0.0268555,1.2069702,0.0805054,1.1533203c0.0060425-0.0060425,0.0498657-0.0077515,0.1080933-0.0078735 l-0.0444946,0.5979614h-0.144104l-0.1072998,0.8582764l0.1482544,0.0244141l-0.1112061,0.8936157l-0.0906372-0.0061035 l-0.0805054,0.7241821l0.0800781,0.0140991l-0.0784302,0.630249l-0.0418701-0.0073242l-0.1005859,0.4224243l0.0869141,0.0311279 l-0.0786743,0.6322632l-0.0752563-0.0130005l-0.0402832,0.4425659l0.0596924,0.0195923l-0.0568848,0.4568481 l-0.0631104-0.0137329l-0.1207275,0.3620605c-0.0075684,0.0227661,0.0492554,0.0578613,0.128479,0.0968018l-0.0480347,0.3859863 l0.0587769-0.3806763c0.3505859,0.1681519,1.2823486,0.4343262,1.2823486,0.4343262l0.0906982-0.2116089 c-0.0077095-0.000885-0.0147591-0.0016632-0.0212288-0.0023499c-0.100769-0.0107117-0.0603294,0.0009537-0.1581345-0.0125961 c-0.0072975-0.0010147-0.0153694-0.0021667-0.0243263-0.003479c-0.3538208-0.0516968-0.8103256-0.1741791-1.1814079-0.3029251 c0.003418,0.0036621,0.104187-0.2428818,0.1666069-0.2347641c0.0676498,0.0192108,0.6252289,0.2204819,0.8015594,0.2644272 c0.1638184,0.0408936,0.3292847,0.0742188,0.4934082,0.1132812l0.0742188-0.1732178l-1.4550171-0.3162842l0.069519-0.4500122 l1.4173431,0.4860687l0.060585-0.1817551c-0.1610718-0.0180054-1.4543457-0.3480606-1.4540405-0.3559341 c0.053009-0.0908737,0.053009-0.1666107,0.060585-0.2953491c0.3407898,0.0378647,1.2655029,0.285202,1.4403076,0.3093719 l0.0484619-0.1549683l-1.5033569-0.2598877l0.0952148-0.6169434l1.4751587,0.5281372l0.0497169-0.1616516 c-0.1315308-0.022522-1.1965561-0.2423401-1.552494-0.4922485c0.0405884,0.1182251-0.0101624-0.3588943,0.0454407-0.196907 c0.0530128,0,1.4297485,0.2907486,1.6096802,0.3176041l0.0488281-0.1708984l-1.605896-0.2800293l0.0968018-0.6268311 l1.6431885,0.289978l0.070385-0.1356735c-0.2077026,0.006958-1.4313202-0.0984497-1.7796822-0.2726288 c-0.005188-0.0009155,0.0534363-0.4437256,0.053009-0.4846802c-0.0003052-0.0286865,1.6014786,0.1807022,1.8368301,0.2109146 l0.0608521-0.2298584l-1.7700806-0.1195679l0.135498-0.8776245l1.8223267,0.2998657l0.0507202-0.1901855 c-0.2114258,0.0002441-1.6663437-0.1216812-2.0149765-0.2522354c0-0.3256454,0.0200043-0.4157867,0.0378685-0.6437149 c0.0549927-0.1401978,2.0451622,0.0517731,2.2000694,0.0600739l0.0482178-0.1809082h-2.0041504l0.0913696-0.5917358 c0.6674805,0.0272827,2.1064453,0.1328735,2.1273193,0.0284424c0.0050049-0.0249634,0.0200806-0.0891724,0.0385742-0.1663208 c-0.2236328,0.0072021-2.3018799,0.0060425-2.3355103-0.0931396c-0.072876-0.2149658-0.0464478-0.4473267-0.0804443-0.6705322 c0.0026245,0.0175171,2.3396606-0.107666,2.6315918-0.1130981c0.0245361-0.0985718,0.0408325-0.1638794,0.0408325-0.1638794 l-2.2436523,0.0211792l0.1549072-1.0032959c0.8800049,0.0757446,2.3114014,0.2175293,2.3301392,0.1238403 c0.005249-0.0262451,0.0297852-0.1203613,0.0600586-0.2347412c-0.4625854-0.0106812-2.8198853-0.1244507-2.8397827-0.1856689 c-0.0724487-0.2229004-0.1226196-0.4362793-0.0805054-0.6705322c0.0079956-0.0444336,0.2572021-0.0390015,0.5047607-0.0274048 c0.2568359-0.0070801,1.4515991-0.1452637,1.8094482-0.1430054c0.2774658-0.0545654,0.5849609-0.0622559,0.8581543-0.0804443 c0.0170898-0.0049438,0.0344238-0.0088501,0.0516968-0.0126343c0.0531616-0.1936035,0.0921631-0.3353271,0.0921631-0.3353271 L40.417141,105.3716583z"
      />
      <path
        opacity="0.42"
        fill="#21376C"
        d="M38.9538078,105.3923645l0.5095978,0.0804901 c0,0-0.0804558,0.1877213-0.1609192,0.1877213s-0.5364304,0.026825-0.5364304,0.026825v-0.3218613L38.9538078,105.3923645z"
      />
      <path
        opacity="0.42"
        fill="#21376C"
        d="M38.3972626,113.4924545 c0.0603485,0,0.6921806,0.1403732,0.6921806,0.1403732l-0.0484657,0.1010208l-0.7040634-0.1005859L38.3972626,113.4924545z"
      />
      <path
        opacity="0.42"
        fill="#21376C"
        d="M38.3369141,114.0355911 c0.0804634,0,0.6369896,0.0268021,0.6369896,0.0268021l0.0469589,0.1743546l-0.7241821-0.0603485L38.3369141,114.0355911z"
      />
      <polygon
        opacity="0.42"
        fill="#21376C"
        points="38.7392349,107.4307938 39.7584534,107.3771515 39.6340599,107.9223175 38.6855927,107.7794724"
      />
      <polygon
        opacity="0.42"
        fill="#21376C"
        points="38.6051292,109.2278366 39.7316322,109.2546539 39.7927513,109.4156036 38.5783081,109.4155884"
      />
      <polygon
        opacity="0.42"
        fill="#21376C"
        points="38.6185379,108.8255157 39.8255043,108.7249298 39.8053894,108.8858643 38.5783081,108.9260941"
      />
      <polygon
        opacity="0.42"
        fill="#21376C"
        points="38.5380745,110.2336426 39.5043602,110.2982941 39.5036469,110.4549179 38.5179596,110.3744507"
      />
      <polygon
        opacity="0.42"
        fill="#21376C"
        points="38.5179596,111.0382843 39.5171776,111.2003326 38.4978409,111.1589813"
      />
      <polygon
        opacity="0.42"
        fill="#21376C"
        points="38.477726,111.7825851 39.4026756,111.9418488 39.34272,112.064209 38.4576111,111.8831635"
      />
      <polygon
        opacity="0.42"
        fill="#21376C"
        points="39.3058739,112.5686798 38.3972626,112.4061813 38.4978409,112.5268784 39.34272,112.6878052"
      />
      <polygon
        opacity="0.42"
        fill="#21376C"
        points="39.1681175,113.0005646 38.3771439,112.9090881 38.3771439,113.070015"
      />
      <polygon
        opacity="0.42"
        fill="#21376C"
        points="38.2966805,115.0212784 38.9200439,114.8906403 38.8196983,115.0011597 38.2765656,115.1822052"
      />
      <path
        opacity="0.42"
        fill="#21376C"
        d="M38.3771439,114.437912l0.6034851,0.0402298 c0,0,0.0201149,0.120697-0.0603485,0.1408157c-0.0804634,0.0201111-0.6236-0.1005859-0.6236-0.1005859L38.3771439,114.437912z"
      />
      <g>
        <path
          fill={colors[0]}
          d="M56.0711937,104.4267883c0,0.4291458,0.6168938,11.0504532,0.6168938,11.0504532l1.7233543,4.277916 l0.3620186,0.8986359h-3.694664l-0.3754997-4.9083328l-2.7357903-11.0772781L56.0711937,104.4267883z"
        />
        <path
          opacity="0.64"
          fill="#21376C"
          d="M58.4114418,119.7551575 c-0.1072845,0.0268173-0.9991722,0.4426651-1.1601028,0.3890228c-0.1609268-0.0536423-1.4215393-0.0536423-1.4215393-0.0536423 l-0.7510033-0.3754959v0.9387512h3.694664L58.4114418,119.7551575z"
        />
        <path
          opacity="0.42"
          fill="#21376C"
          d="M56.4529724,115.4854889l0.3491058,1.5876312 c0,0-0.8851089-0.6437149-1.9512634,0.3419724c-0.0402298-0.784523,0.864994-1.2471924,1.0661545-1.2673111 c0.2212791-0.0402298,0.0804634-0.5632553,0.0804634-0.5632553L56.4529724,115.4854889z"
        />
        <path
          opacity="0.42"
          fill="#21376C"
          d="M56.7149086,117.0060654l0.3486786,1.394722 c0,0-0.8448753-0.5230179-1.6495209,0.2011566c0.120697-0.6437149,1.2472-0.8046417,1.2472-0.8046417l-0.1609306-0.978981 L56.7149086,117.0060654z"
        />
        <path
          opacity="0.42"
          fill="#21376C"
          d="M54.500576,105.3716583l-0.1459351-0.9448853 l0.5900269,0.0805054l0.0684204,0.9187622l0.4412231,0.046814c0,0-0.0268555,1.2069702-0.0805054,1.1533203 c-0.0095215-0.0095215-0.1125488-0.0059814-0.2709351,0.0049438l0.0773315,1.0385132l0.2741089,0.0025635 c0,0-0.0268555,1.2069702-0.0805054,1.1533203c-0.0060425-0.0060425-0.0498657-0.0077515-0.1080933-0.0078735 l0.0444946,0.5979614h0.144104l0.1072998,0.8582764l-0.1482544,0.0244141l0.1112061,0.8936157l0.0906372-0.0061035 l0.0805054,0.7241821l-0.0800781,0.0140991l0.0784302,0.630249l0.0418701-0.0073242l0.1005859,0.4224243l-0.0869141,0.0311279 l0.0786743,0.6322632l0.0752563-0.0130005l0.0402832,0.4425659l-0.0596924,0.0195923l0.0568848,0.4568481l0.0631104-0.0137329 l0.1207275,0.3620605c0.0075684,0.0227661-0.0492554,0.0578613-0.128479,0.0968018l0.0480347,0.3859863l-0.0587769-0.3806763 c-0.3505859,0.1681519-1.2823486,0.4343262-1.2823486,0.4343262l-0.0906982-0.2116089 c0.0077057-0.000885,0.0147552-0.0016632,0.021225-0.0023499c0.100769-0.0107117,0.0603333,0.0009537,0.1581345-0.0125961 c0.0073013-0.0010147,0.0153694-0.0021667,0.0243263-0.003479c0.3538208-0.0516968,0.8103256-0.1741791,1.1814079-0.3029251 c-0.003418,0.0036621-0.104187-0.2428818-0.1666069-0.2347641c-0.0676498,0.0192108-0.6252251,0.2204819-0.8015556,0.2644272 c-0.1638184,0.0408936-0.3292847,0.0742188-0.4934082,0.1132812l-0.0742188-0.1732178l1.4550171-0.3162842l-0.069519-0.4500122 l-1.4173431,0.4860687l-0.060585-0.1817551c0.1610718-0.0180054,1.4543457-0.3480606,1.4540405-0.3559341 c-0.0530128-0.0908737-0.0530128-0.1666107-0.060585-0.2953491c-0.3407936,0.0378647-1.2655029,0.285202-1.4403076,0.3093719 l-0.0484619-0.1549683l1.5033569-0.2598877l-0.0952148-0.6169434l-1.4751587,0.5281372l-0.0497169-0.1616516 c0.1315308-0.022522,1.1965523-0.2423401,1.5524902-0.4922485c-0.0405884,0.1182251,0.0101624-0.3588943-0.0454407-0.196907 c-0.053009,0-1.4297447,0.2907486-1.6096764,0.3176041l-0.0488281-0.1708984l1.605896-0.2800293l-0.0968018-0.6268311 l-1.6431885,0.289978l-0.0703888-0.1356735c0.2077026,0.006958,1.4313202-0.0984497,1.779686-0.2726288 c0.005188-0.0009155-0.0534401-0.4437256-0.0530128-0.4846802c0.0003052-0.0286865-1.6014748,0.1807022-1.8368263,0.2109146 l-0.0608521-0.2298584l1.7700806-0.1195679l-0.135498-0.8776245l-1.8223267,0.2998657l-0.0507202-0.1901855 c0.2114258,0.0002441,1.6663399-0.1216812,2.0149727-0.2522354c0-0.3256454-0.0200005-0.4157867-0.0378647-0.6437149 c-0.0549927-0.1401978-2.0451622,0.0517731-2.2000694,0.0600739l-0.0482178-0.1809082h2.0041504l-0.0913696-0.5917358 c-0.6674805,0.0272827-2.1064453,0.1328735-2.1273193,0.0284424c-0.0050049-0.0249634-0.0200806-0.0891724-0.0385742-0.1663208 c0.2236328,0.0072021,2.3018799,0.0060425,2.3355103-0.0931396c0.072876-0.2149658,0.0464478-0.4473267,0.0804443-0.6705322 c-0.0026245,0.0175171-2.3396606-0.107666-2.6315918-0.1130981c-0.0245361-0.0985718-0.0408325-0.1638794-0.0408325-0.1638794 l2.2436523,0.0211792l-0.1549072-1.0032959c-0.8800049,0.0757446-2.3114014,0.2175293-2.3301392,0.1238403 c-0.005249-0.0262451-0.0297852-0.1203613-0.0600586-0.2347412c0.4625854-0.0106812,2.8198853-0.1244507,2.8397827-0.1856689 c0.0724487-0.2229004,0.1226196-0.4362793,0.0805054-0.6705322c-0.0079956-0.0444336-0.2572021-0.0390015-0.5047607-0.0274048 c-0.2568359-0.0070801-1.4515991-0.1452637-1.8094482-0.1430054c-0.2774658-0.0545654-0.5849609-0.0622559-0.8581543-0.0804443 c-0.0170898-0.0049438-0.0344238-0.0088501-0.0516968-0.0126343c-0.0531616-0.1936035-0.0921631-0.3353271-0.0921631-0.3353271 L54.500576,105.3716583z"
        />
        <path
          opacity="0.42"
          fill="#21376C"
          d="M56.0476837,105.2917786l-0.5095978,0.0804901 c0,0,0.080452,0.1877289,0.1609154,0.1877289c0.0804672,0,0.5364304,0.0268173,0.5364304,0.0268173v-0.3218536 L56.0476837,105.2917786z"
        />
        <path
          opacity="0.42"
          fill="#21376C"
          d="M56.604229,113.3918686 c-0.0603485,0-0.6921806,0.1403732-0.6921806,0.1403732l0.0484657,0.1010208l0.7040634-0.1005783L56.604229,113.3918686z"
        />
        <path
          opacity="0.42"
          fill="#21376C"
          d="M56.6645775,113.9350052 c-0.0804634,0-0.6369896,0.0268021-0.6369896,0.0268021l-0.0469589,0.1743622l0.7241783-0.0603485L56.6645775,113.9350052z"
        />
        <polygon
          opacity="0.42"
          fill="#21376C"
          points="56.2622528,107.3302155 55.2430382,107.2765732 55.3674316,107.8217316 56.3158989,107.678894"
        />
        <polygon
          opacity="0.42"
          fill="#21376C"
          points="56.3963623,109.1272507 55.2698593,109.1540756 55.2087402,109.3150177 56.4231834,109.3150024"
        />
        <polygon
          opacity="0.42"
          fill="#21376C"
          points="56.3829498,108.7249298 55.1759834,108.6243515 55.1960983,108.7852783 56.4231834,108.8255157"
        />
        <polygon
          opacity="0.42"
          fill="#21376C"
          points="56.4634171,110.1330566 55.4971313,110.1977081 55.4978409,110.3543396 56.483532,110.2738724"
        />
        <polygon
          opacity="0.42"
          fill="#21376C"
          points="56.483532,110.937706 55.484314,111.0997467 56.5036469,111.058403"
        />
        <polygon
          opacity="0.42"
          fill="#21376C"
          points="56.5237656,111.6819992 55.5988159,111.8412628 55.6587715,111.9636307 56.5438805,111.7825851"
        />
        <polygon
          opacity="0.42"
          fill="#21376C"
          points="55.6956177,112.4680939 56.604229,112.305603 56.5036469,112.4263 55.6587715,112.5872269"
        />
        <polygon
          opacity="0.42"
          fill="#21376C"
          points="55.833374,112.8999786 56.6243439,112.8085022 56.6243439,112.9694366"
        />
        <polygon
          opacity="0.42"
          fill="#21376C"
          points="56.7048073,114.9207001 56.0814476,114.790062 56.1817894,114.9005814 56.724926,115.0816269"
        />
        <path
          opacity="0.42"
          fill="#21376C"
          d="M56.6243439,114.337326l-0.6034813,0.0402374 c0,0-0.0201187,0.120697,0.0603485,0.1408081c0.0804634,0.0201187,0.6235962-0.1005783,0.6235962-0.1005783 L56.6243439,114.337326z"
        />
      </g>
    </g>
  )
}

export default Boots
